export default __webpack_public_path__ + "static/media/a8abc20c-6ce3-48be-b25e-41ae3c6e0379.640ff8b3.eot";